// extracted by mini-css-extract-plugin
export default {"labelWrapper":"LandscapeImageBlockAddTemplate_labelWrapper__hXONO"};